var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.44682,
    height: 27.5,
    viewBox: "0 0 62.44682 27.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fcea2b;}.cls-3{fill:#92d3f5;}.cls-4{fill:#9b9b9a;}.cls-5{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.8,15.1l-1.1-.6c-.4-.2-.6-.6-.5-1,.3-1.9,.5-8.5-9.7-11.5-.2-.1-.4-.1-.6-.1l-19.6,.1c-.4,0-.8,.1-1.1,.3l-10.3,6.9c-.2,.1-.4,.2-.6,.2-1.9-.1-3.7,.1-5.6,.4-5.4,1.1-7.6,4-8.4,5.5-.2,.3-.2,.7-.2,1,.1,2.4-1.5,5.1,.9,7.3l19.4-.1,20.4-.5,16.1-.2c.9-.1001,2.4-1.4,2.8-2.2001,1.7-2.69991-1.7-5.39991-1.9-5.4999Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M12.3,17.5c-2.2,0-4,1.8-4,4s1.8,4,4,4,4-1.8,4-4-1.8-4-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52.1,17.5c-2.2,0-4,1.8-4,4s1.8,4,4,4,4-1.8,4-4-1.8-4-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.1,10.4V6.1c0-.9-.8-1.7-1.7-1.7H28.2c-.1,0-.2,0-.2,.1l-8,5.7c-.2,.1-.2,.4-.1,.6,.1,.1,.2,.2,.3,.2,5.6,0,27.2-.2,30.4-.1,.3,0,.5-.2,.5-.5q0,.1,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.9 11.6 7.9 13.2 5.8 16.1 .8 16.2 3.9 11.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 42.6,
    y1: 22.1,
    x2: 22,
    y2: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M3.1,22.5c-.9-.2-1.7-.5-1.8-1-.1-1-.3-3.8-.3-5.1,0-.5,.1-1.1,.4-1.5,1.1-2,4.8-6.8,14.9-6.4L26.6,1.6c.5-.3,1.1-.5,1.6-.5l19.6-.1c.3,0,.6,0,.9,.1,2.2,.6,11.7,4,10.4,12.6l1.1,.6c.5,.2,.9,.7,1,1.2,.4,1.4,.3,2.9-.2,4.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "19.9 11 50.1 10.8 50.1 6.3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 12.3,
    cy: 21.5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 52.1,
    cy: 21.5,
    r: 5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "7.3 14 5.5 16.2 1.8 16.1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.6f46d61c5cd3acb87dd29c605574c60c.svg";
export { ForwardRef as ReactComponent };